import vest, { create, test, enforce } from 'vest'
import isCreditCard from 'validator/lib/isCreditCard'
import { CreditCardFormState } from '~/types'

import { initialFormState as initialData } from '.'

enforce.extend({ isCreditCard })

export default create(
  'add_card_form',
  (data: CreditCardFormState = initialData, currentField: keyof CreditCardFormState) => {
    vest.only(currentField)

    // cardNumber: カード番号
    test('cardNumber', 'カード番号は必須です', () => {
      enforce(data.cardNumber).isNotEmpty()
    })

    test('cardNumber', '不正なカード番号です', () => {
      enforce(data.cardNumber).isCreditCard()
    })

    // expMonth: 有効期限（月）
    test('expMonth', '有効期限（月）は必須です', () => {
      enforce(data.expMonth).isNotEmpty()
    })

    test('expMonth', '有効期限（月）は数値で入力してください', () => {
      enforce(data.expMonth).isNumeric()
    })

    test('expMonth', '有効期限（月）の値が不正です', () => {
      enforce(data.expMonth).isBetween(1, 12)
    })

    // expYear: 有効期限（年）
    test('expYear', '有効期限（年）は必須です', () => {
      enforce(data.expYear).isNotEmpty()
    })

    test('expYear', '有効期限（年）は数値で入力してください', () => {
      enforce(data.expYear).isNumeric()
    })

    test('expYear', '有効期限（年）の値が不正です', () => {
      enforce(data.expYear).isBetween(21, 99)
    })

    // cvc: セキュリティコード
    test('cvc', 'セキュリティコードは必須です', () => {
      enforce(data.cvc).isNotEmpty()
    })

    test('cvc', 'セキュリティコードは数値で入力してください', () => {
      enforce(data.cvc).isNumeric()
    })

    test('cvc', 'セキュリティコードの値が不正です', () => {
      enforce(data.cvc).longerThanOrEquals(3)
    })

    test('cvc', 'セキュリティコードの値が不正です', () => {
      enforce(data.cvc).shorterThanOrEquals(4)
    })
  }
)
